import ClinicProfile from './ClinicProfile';

export default ClinicProfile;
